import React, { useEffect, useState } from 'react'
import {
  Modal,
  Form,
  Input,
  Button,
  message,
  Radio,
  InputNumber,
  Select
} from 'antd'
import ModalCustom from '../common/Modal/ModalCustom'
import styles from './styles.module.scss'
import { TIME_PACKAGE_DAYS, TIME_PAKAGE } from '../../configData'
import { getPakageCommunity } from '../../services/pakage-community-service'
import { formatCurrencyLabel, removeVietnameseTones } from '../../config-func'
import dayjs from 'dayjs'
import { useWatch } from 'antd/es/form/Form'
const ModalExtensionComunity = ({
  visible,
  onCancel,
  onFinish,
  detailUser
}) => {
  const [form] = Form.useForm()
  const [dataPakage, setDataPakage] = useState([])
  const customizeRequiredMark = (label, { required }) => (
    <>
      {label}
      {required && <span style={{ color: 'red' }}> *</span>}
    </>
  )

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      onFinish(values)
      form.resetFields()
    } catch (error) {
      console.log('Validation failed:', error)
    }
  }

  async function fetchDataPakage() {
    let _dataSource = []

    const params = {
      page: 1,
      pageSize: 1000,
      sort: 'ASC',
      sortBy: 'type',
      status: 1
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getPakageCommunity(cleanedData)
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setDataPakage(_dataSource)
    }
  }

  useEffect(() => {
    if (visible) {
      fetchDataPakage()
    }
  }, [visible])

  return (
    <ModalCustom
      title="Gia hạn cộng đồng"
      open={visible}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            form.resetFields()
            onCancel()
          }}
        >
          Hủy
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Thanh toán
        </Button>
      ]}
      width={700}
    >
      <Form
        form={form}
        // onFinish={handleOk}
        labelAlign="left"
        labelCol={{ span: 10 }}
        labelWrap
        layout="horizontal"
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        requiredMark={customizeRequiredMark}
      >
        <Form.Item label="" name="id" style={{ display: 'none' }}>
          <Input />
        </Form.Item>

        <Form.Item
          className={styles.formItem}
          rules={[{ required: true, message: 'Vui lòng chọn loại gói!' }]}
          label="Chọn gói gia hạn"
          name="type"
        >
          <Select
            style={{ width: '100%' }}
            placeholder="Chọn gói"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase()
              const optionValue = removeVietnameseTones(
                option?.children || ''
              ).toLowerCase()
              return optionValue.includes(inputValue)
            }}
            onChange={(value) => {
              const selectedOption = dataPakage.find(
                (item) => item.id === value
              )

              
              const daysToAdd = TIME_PACKAGE_DAYS[selectedOption?.type] || 0

              const isoString = detailUser?.user_account_info?.date_end_communi
              const timestamp = dayjs(isoString).valueOf() // trả về number
              // const timestamp = 1747699200000
              const currentDate = dayjs().valueOf()
              const promotionDate = selectedOption?.promotion_date && selectedOption?.promotion_date * 24 * 60 * 60 * 1000;


              const newDate = timestamp  + promotionDate 
              const newCurrentDate = currentDate  + promotionDate

              // đã có ngày gia hạn
              const formattedDate = dayjs(newDate).format('YYYY-MM-DD')
              const datePlusMonth = dayjs(formattedDate).add(daysToAdd, 'month').format('DD/MM/YYYY');

              // ko có gói nào
              const formattedCurrentDate = dayjs(newCurrentDate).format('YYYY-MM-DD')
              const datePlusMonthCurrent = dayjs(formattedCurrentDate).add(daysToAdd, 'month').format('DD/MM/YYYY');
             
              form.setFieldsValue({
                original_price: formatCurrencyLabel(
                  selectedOption?.original_price
                ),
                promotion_date: selectedOption?.promotion_date,
              })
              if (isoString && dayjs(isoString).isAfter(dayjs())) {
                form.setFieldsValue({
                  date_expired: datePlusMonth
                })
              } else {
                form.setFieldsValue({
                  date_expired: datePlusMonthCurrent
                })
              }
            }}
          >
            {dataPakage?.map((item, idx) => (
              <Option key={idx} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tổng thanh toán"
          name="original_price"
          // rules={[{ required: true, message: 'Vui lòng nhập giá!' }]}
          className={styles.formItem}
        >
          <Input placeholder="" disabled style={{ color: '#000' }} />
        </Form.Item>

        <Form.Item
          label="Số ngày được khuyến mãi"
          name="promotion_date"
          className={styles.formItem}
        >
          <Input disabled style={{ color: '#000' }} />
        </Form.Item>
        <Form.Item
          label="Ngày hết hạn cộng đồng dự kiến"
          name="date_expired"
          className={styles.formItem}
        >
          <Input disabled style={{ color: '#000' }} />
        </Form.Item>
      </Form>
    </ModalCustom>
  )
}

export default ModalExtensionComunity
